<template>
<div class="featured-dorms section">
<!--     <div class="vld-parent mycenter">
      <loading :active.sync="isLoading" 
      :is-full-page="fullPage"></loading>
    </div>  --> 
  <container>
    <div class="section__header">
      <div class="section__title">
        <span class="color-pink">Most Popular</span> Movies
      </div>    
      <div class="section__right">
        <!--<div v-for="(city,index) in cities" :key="city.id">-->
          <!--<SubpageCategory :links="city" @click.native="handleClickNavItem(index)" :class="{active : index===currentNav}" class="DesktopTab"/>-->
        <!--</div>-->
        <div class="subpage-nav__list DesktopTab">
          <div class="subpage-nav__item" v-if="currentNav !== null">
            <button class="subpage-nav__link" @click="clearFilter">
              <span class="button__wrp">
                <span class="btn-txt">
                  See All
                </span>
              </span>
            </button>
          </div>
          <div class="subpage-nav__item" v-for="(movie, $index) in cities" :key="movie.id">
            <button class="subpage-nav__link" @click="filterDorms(movie.id, $index)" :class="{ active : $index === currentNav }">
              <span class="button__wrp">
                <span class="btn-txt">
                  {{ movie.name }}
                </span>
              </span>
            </button>
          </div>
        </div>
        <div class="mobileTab">
          <!-- <select-box @onselect="getMovies" :options="cities" title="Select Genre"/> -->
          <v-select :options="cities" placeholder="Select Genre" @onselect="getMovies"/>
        </div>

        <!--<div class="mobileTab">-->
          <!--<select-box :options="linkMobile" title="Select Genre"/>-->
        <!--</div>-->
      </div>
    </div>
      <ContentLoader v-if="!dorms && !mobileCheck"
      :height="900">
        <rect x="3" y="0" rx="3" ry="3" width="94" height="110" />
        <rect x="103" y="0" rx="3" ry="3" width="94" height="110" />
        <rect x="203" y="0" rx="3" ry="3" width="94" height="110" />
        <rect x="305" y="0" rx="3" ry="3" width="94" height="110" />
        
        <rect x="3" y="115" rx="3" ry="3" width="94" height="110" />
        <rect x="103" y="115" rx="3" ry="3" width="94" height="110" />
        <rect x="203" y="115" rx="3" ry="3" width="94" height="110" />
        <rect x="305" y="115" rx="3" ry="3" width="94" height="110" />        
      </ContentLoader>  
      <ContentLoader v-if="!dorms && mobileCheck">
        <rect x="3" y="0" rx="3" ry="3" width="94" height="110" />      
      </ContentLoader>       
    <div class="featured-dorms__cnt">
      <div class="featured-dorms__list dorm-card__list">
        <swiper :options="swiperOption" style="display: none">
          <swiper-slide
            v-for="dorm in dorms"
            :key="dorm.id"
            class="featured-dorms__col col-xl-3 col-lg-3 col-md-4">
            <dorm-card
              :dorm="dorm"
            />
          </swiper-slide>
          <div class="swiper-paginations" style="text-align: center;" slot="pagination"></div>
        </swiper>
        <div
          v-for="dorm in dorms"
          :key="dorm.id"
          class="featured-dorms__col desktop-dorm col-xl-3 col-lg-3 col-md-4">
          <movie-card
            :movie="dorm"
          />
        </div>

        <empty-content :content="emptyContent" v-if="dorms && dorms.length === 0"/>
      </div>

      <div class="featured-dorms__bottom text-center">
<!--         <v-link
        :to="{ name: linkMobile.name }"
          class="button--stroke round icon-transform"
          title="Tüm Yurtlar"
          icon="icon-arrow-long-right"
          icon-position="right"
        />  -->

<!--       <v-button
        class="button--stroke round icon-transform"
        @click.native="allDorms"
        icon="icon-arrow-long-right"
        icon-position="right"
        title="Tüm Yurtlar"
      />  -->    


      </div>

    </div>

  </container>

   <!-- Fixed Button -->
<!--        <v-button
        class="button green round getBid"
        icon="icon-fiyat-sor"
        icon-position="left"
        title="Tüm Yurtlardan Teklif Al"
      />   -->  
<!-- Fixed Button End -->
</div>
</template>

<script>
import MovieCard from '@/components/MovieCard'
import SubpageCategory from '@/components/SubpageCategory'
import SelectBox from '@/components/SelectBox'
import EmptyContent from '@/components/EmptyContent'
import axios from 'axios'
// import Loading from 'vue-loading-overlay';
import { ContentLoader } from 'vue-content-loader'
export default {
  name: 'FeaturedMovies',
  components: {
    EmptyContent,
    MovieCard,
    SelectBox,
    ContentLoader
  },
  data () {
    return { 
      isLoading: false,
      fullPage: true, 
      city: null,
      currentNav: null,
      dorms: null,
      swiperOption: {
        slidesPerView: 2,
        spaceBetween: 20,
        slidesPerGroup: 2,
        breakpoints: {
          768: {
            slidesPerView: 'auto',
            centeredSlides: false,
            slidesPerGroup: 2
          },
          640: {
            slidesPerView: 'auto',
            centeredSlides: 'center',
            slidesPerGroup: 1
          },
          320: {
            slidesPerView: 'auto',
            centeredSlides: false,
            slidesPerGroup: 1

          }
        },
        pagination: {
          el: '.swiper-paginations',
          clickable: true
        }
      },
       cities: [
        {
          id: 28,
          name: 'Popular',
          keyword: 'popular',
        },
        {
          id: 12,
          name: 'Now Playing',
          keyword: 'now_playing',
        },
        {
          id: 27,
          name: 'Top Rated',
          keyword: 'top_rated',
        },
        {
          id: 878,
          name: 'Coming Soon',
          keyword: 'upcoming',
        }/*,
        {
          id: 878,
          name: 'Latest',
          keyword: 'latest',
        }*/
      ],
      emptyContent: {
        icon: 'icon-search',
        title: 'No Result!',
        text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Assumenda dolor, dolorem fugit in quis velit!'
      },
      mainDorms: []
    }
  },
  methods: {
mobileCheck() {
  var check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check
  },    
      selectCity (opt) {
        const city = this.cities.find((city) => city.id == opt.id)
        const index = this.cities.indexOf(city)
        this.filterDorms (opt.id, index)
    },
    allDorms () {
      let slug = ''
      if(this.currentNav == null) {
        slug = 'universiteler'
      } else {
         slug = this.cities[this.currentNav].slug + '-ozel-ogrenci-yurtlari/'
      }
      this.$router.push(slug) 
    },
    getMovies (opt) {
      let self = this
      this.isLoading = true
      //axios.get('/site/home/showcase-promote-dorms')
      axios.get(`/3/movie/${opt.keyword}?api_key=a11ac97c6bdb99adc0845654be0902a8&language=en-US&page=1`)
        .then(response => {
          this.isLoading = false
          self.dorms = response.data.results.slice(0, 4);
          self.mainDorms = response.data.results
          // self.cities = response.data.cities
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    filterDorms (id, index) {
      this.currentNav = index
      let self = this
      this.isLoading = true
      //axios.get(`/site/home/showcase-promote-dorms?city=${id}`)
      axios.get(`/3/discover/movie?api_key=a11ac97c6bdb99adc0845654be0902a8&with_genres=${id}&page=1`)
        .then(response => {
          this.isLoading = false
          self.dorms = response.data.results
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    clearFilter () {
      this.dorms = this.mainDorms
      this.currentNav = null
    }
  },
  created () {
    this.getMovies({keyword:'popular'})
  },
  Computed: {
    mobileCheck() {
  var check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check
  }    
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/components/featured-dorms";
</style>
